/*
$.fixedHero();
specify a #hero-image id and then it will calculate the height of the masthead and transition to
position fixed. This may not work well if the hero is in the html of the page for touch devices
in that case we may want to turn it off if touch = true
*/

(function ($) {
    var $window = $(window);

    $.fn.fixedHero = function (args) {
        var options = {
            minWidth: 1030
        };

        return this.each(function () {
            var isFixed = false,
                $heroImg = $(this),
                headerHeight = $heroImg.offset().top,
                winWidth = $window.width();

            if (winWidth > options.minWidth) {
                $window.trigger('scroll.fixedHero'); //just making sure we have it in the right position

                $window.on('scroll.fixedHero', function () {
                    var $this = $(this);

                    if ($this.scrollTop() > headerHeight && isFixed === false) {
                        $heroImg.addClass('fixed');
                        isFixed = true;
                    } else
                        if ($this.scrollTop() < headerHeight && isFixed === true) {
                            $heroImg.removeClass('fixed');
                            isFixed = false;
                        }
                });
            }
        });
    };
})(jQuery);